import Vue from "vue";

export class Atendimento {
    static create() {
        return {
            contrato: null,
            acoes: [],
            obs: null,
            motivo: {
                _id: null
            }
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("atendimento/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("atendimento/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static byContrato(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("atendimento/by-contrato/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("atendimento/" + data._id, data);
            } else {
                promisse = Vue.http.post("atendimento/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
